<template>
  <div>
    <div class="p pb-none flex-shrink">
      <ak-modal-title class="ml-small">Edit HTML</ak-modal-title>
    </div>
    <div class="flex__item is-scrollable">
      <ak-tabs v-model="activeTab" class="htmlEditorTabs">
        <ak-tab-item label="Rich Text Editor">
          <ak-text-editor
            v-if="activeTab === 0"
            v-model="contentModel.content"
            :config="textConfig"
            language="html"
          />
        </ak-tab-item>
        <ak-tab-item label="HTML Editor">
          <ak-code-editor
            v-if="activeTab === 1"
            v-model="contentModel.content"
            language="html"
          />
        </ak-tab-item>
      </ak-tabs>
    </div>
  </div>
</template>

<script>
import TextEditor from '@akerolabs/akero-vue/src/components/textEditor/TextEditor'
import CodeEditor from '@akerolabs/akero-vue/src/components/codeEditor/CodeEditor.vue'
import Tabs from '@akerolabs/akero-vue/src/components/tabs/Tabs.vue'
import TabItem from '@akerolabs/akero-vue/src/components/tabs/TabItem.vue'
import { defineComponent, ref, computed } from 'vue'
import config from '../../utils/config'

export default defineComponent({
  components: {
    [TextEditor.name]: TextEditor,
    [CodeEditor.name]: CodeEditor,
    [Tabs.name]: Tabs,
    [TabItem.name]: TabItem,
  },

  props: {
    /**
     * @type {Object}
     * @description The content to render/edit
     */
    modelValue: {
      type: Object,
      default: () => ({
        content: config.defaultContent,
        type: 'html',
        style: {},
      }),
    },
  },

  setup(props) {
    const contentModel = computed(() => props.modelValue.value)
    const activeTab = ref(0)

    const textConfig = ref({
      allowedContent: true,
      extraPlugins:
        'sharedspace,colorbutton,colordialog,font,justify,akvariables,autogrow',
      removePlugins: 'dragdrop,basket,exportpdf',
      autoGrow_minHeight: 250,
      autoGrow_maxHeight: 600,
      autoGrow_onStartup: true,
      autoGrow_bottomSpace: 50,
      toolbar: [
        ['FontSize', 'Bold', 'Italic', 'Underline'],
        ['TextColor', 'BGColor'],
        ['Link', 'Unlink'],
        ['NumberedList', 'BulletedList'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
        ['RemoveFormat'],
        ['AKVariables'],
      ],
    })

    return {
      activeTab,
      textConfig,
      contentModel,
    }
  },
})
</script>

<style lang="sass">
.htmlEditorTabs {
  .cke {
    width:100%!important;
  }
}
</style>
